import React from 'react';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleFilterSearchButtonProps {
  testId?: string;
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const PowerOutageScheduleFilterSearchButton: React.FC<
  PowerOutageScheduleFilterSearchButtonProps
> = ({ testId, className, onChange, value }) => {
  return (
    <div className="relative w-full">
      <SVGImage
        name="search"
        className="absolute left-2 top-1/2 -translate-y-1/2"
      />
      <input
        type="text"
        data-testId={testId}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className={`noto-normal-3 h-[26px] w-full rounded-[5px] border border-light-6 py-[5px] pl-6 leading-[23px] tracking-[-0.5px] text-dark-6 focus:outline-none ${className}`}
      ></input>
    </div>
  );
};
